'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'sun-bright';
var width = 512;
var height = 512;
var aliases = ["sun-alt"];
var unicode = 'e28f';
var svgPathData = 'M256 512c-8.8 0-16-7.2-16-16l0-72c0-8.8 7.2-16 16-16s16 7.2 16 16l0 72c0 8.8-7.2 16-16 16zm0-408c-8.8 0-16-7.2-16-16l0-72c0-8.8 7.2-16 16-16s16 7.2 16 16l0 72c0 8.8-7.2 16-16 16zM437 437c-6.2 6.2-16.4 6.2-22.6 0l-50.9-50.9c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L437 414.4c6.2 6.2 6.2 16.4 0 22.6zM148.5 148.5c-6.2 6.2-16.4 6.2-22.6 0L75 97.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l50.9 50.9c6.2 6.2 6.2 16.4 0 22.6zM496 272l-72 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l72 0c8.8 0 16 7.2 16 16s-7.2 16-16 16zM88 272l-72 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l72 0c8.8 0 16 7.2 16 16s-7.2 16-16 16zM437 75c6.2 6.2 6.2 16.4 0 22.6l-50.9 50.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L414.4 75c6.2-6.2 16.4-6.2 22.6 0zM148.5 363.5c6.2 6.2 6.2 16.4 0 22.6L97.6 437c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l50.9-50.9c6.2-6.2 16.4-6.2 22.6 0zM336 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-192 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSunBright = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;